import ChartLoading from '@/components/common/charts/ChartLoading';
import FadeInBox from '@/components/common/FadeInBox';
import { FlexRow } from '@/components/common/Flex';
import { useQuery } from '@apollo/client';
import { GoalEntitiesValueSeriesDocument } from '@common/graphql/generated';
import { getGoalAccounts } from '@common/react/goals';
import { usePageContext } from '@common/react/pageMode';
import { dt } from '@common/util/dateTime';
import { GoalEntitiesValueSeries } from '@common/valueSeries/buildGoalEntitiesValueSeries';
import { useGoalDetailChartRangeControls } from '../goalChartHelper';
import GoalsChartContainer from '../GoalsChartContainer';
import { useGoalDetailContext } from './GoalDetailContext';

const CHART_CONTAINER_PROPS = {
    h: 280,
    pt: 12,
    px: 16,
};

export default function GoalDetailChart() {
    const { goal } = useGoalDetailContext();
    const { pageMode } = usePageContext();

    const rangeControls = useGoalDetailChartRangeControls({
        accounts: goal ? getGoalAccounts(goal) : [],
    });

    const { data: valueSeriesData, loading: valueSeriesLoading } = useQuery(
        GoalEntitiesValueSeriesDocument,
        goal
            ? {
                  variables: {
                      goalId: goal.id,
                      range: rangeControls.range,
                      pageMode,
                      currentDate: dt().toDateStr(),
                  },
              }
            : { skip: true }
    );

    if (!valueSeriesData?.goalEntitiesValueSeries || valueSeriesLoading) {
        return (
            <FlexRow {...CHART_CONTAINER_PROPS}>
                <ChartLoading />
            </FlexRow>
        );
    }

    return (
        <FadeInBox>
            <GoalsChartContainer
                {...CHART_CONTAINER_PROPS}
                chartEntities={
                    valueSeriesData.goalEntitiesValueSeries as GoalEntitiesValueSeries[]
                }
                {...rangeControls}
            />
        </FadeInBox>
    );
}
